import { NgModule } from '@angular/core';
import { QuillEditorComponent } from './quill-editor.component';
var QuillModule = (function () {
    function QuillModule() {
    }
    QuillModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [
                        QuillEditorComponent
                    ],
                    imports: [],
                    exports: [QuillEditorComponent],
                    providers: []
                },] },
    ];
    /** @nocollapse */
    QuillModule.ctorParameters = function () { return []; };
    return QuillModule;
}());
export { QuillModule };
//# sourceMappingURL=quill.module.js.map


//////////////////
// WEBPACK FOOTER
// C:/projects/wct-nextias-ui/node_modules/ngx-quill/src/quill.module.js
// module id = ../../../../ngx-quill/src/quill.module.js
// module chunks = common